'use client';

import * as Checkbox from '@/components/Checkbox';
import { usePageTextContent } from '@/context/pageTextContent';

export type CategoriesSectionProps = {
  categories: Category[];
  onChange(categoryId: string): void;
  isChecked(categoryId: string): boolean;
};

export function CategoriesSection({
  categories,
  onChange,
  isChecked,
}: CategoriesSectionProps) {
  const { content } = usePageTextContent<SearchPageContent>();

  const { categories: categoriesContent } = content;

  function onCategoryChange(categoryId: string) {
    return () => {
      onChange(categoryId);
    };
  }

  return (
    <div className="flex w-full flex-col items-start space-y-3.5 px-10 pb-7">
      <h2 className="text-2xl">{categoriesContent}</h2>

      {categories.map(category => (
        <div key={category.id} className="flex w-full flex-col items-start">
          <p>{category.name}</p>

          <div className="grid w-full grid-cols-2 gap-x-8 gap-y-2 md:grid-cols-2 lg:grid-cols-3">
            {category.children.map(subcategory => (
              <Checkbox.Root key={subcategory.id}>
                <Checkbox.Control
                  onCheckedChange={onCategoryChange(subcategory.id)}
                  checked={isChecked(subcategory.id)}
                >
                  <Checkbox.Indicator>
                    <Checkbox.CheckIcon />
                  </Checkbox.Indicator>
                </Checkbox.Control>
                <Checkbox.Label>{subcategory.name}</Checkbox.Label>
              </Checkbox.Root>
            ))}
          </div>

          <hr className="mt-4 w-full" />
        </div>
      ))}
    </div>
  );
}
